import { useEffect, useRef } from 'react';

interface UseScanSearchProps {
  isActive?: boolean;
}

const MAX_TIME = 20;

export const useScanSearch = ({ isActive = true }: UseScanSearchProps = {}) => {
  const callbackRef = useRef<(code: string) => void>(() => {});
  const bufferRef = useRef<string>('');
  const lastKeyTimeRef = useRef<number>(0);

  useEffect(() => {
    if (!isActive) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (!(event.target instanceof HTMLBodyElement)) {
        return;
      }

      const currentTime = event.timeStamp;
      const timeDiff = currentTime - lastKeyTimeRef.current;
      lastKeyTimeRef.current = currentTime;

      if (bufferRef.current.length > 0 && timeDiff > MAX_TIME) {
        bufferRef.current = '';
      }

      if (event.key === 'Enter') {
        if (bufferRef.current.trim() !== '') {
          callbackRef.current(bufferRef.current);
          bufferRef.current = '';
          lastKeyTimeRef.current = 0;
        }
        return;
      }

      if (event.key.length > 1) return;

      bufferRef.current += event.key;
    };

    globalThis.addEventListener('keydown', handleKeyDown);
    return () => globalThis.removeEventListener('keydown', handleKeyDown);
  }, [isActive]);

  const onScan = (callback: (code: string) => void) => {
    callbackRef.current = callback;
  };

  return { onScan };
};
